import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="w-full max-w-4xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
          开启您的视频探索之旅
        </h2>
        <p className="text-foreground-500 text-base md:text-lg mb-8 max-w-xl mx-auto">
          加入数百万用户的选择，发现更多精彩内容。每日更新热门视频推荐，不错过每一部好作品。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-white font-semibold rounded-full hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/20"
          >
            开始探索
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-4 border-2 border-foreground-300 text-foreground-700 font-semibold rounded-full hover:border-primary-500 hover:text-primary-600 transition-colors"
          >
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-6 gap-4 md:gap-6 opacity-60">
          {[
            { icon: 'ri-movie-2-line', label: '电影' },
            { icon: 'ri-tv-line', label: '剧集' },
            { icon: 'ri-emotion-laugh-line', label: '综艺' },
            { icon: 'ri-ghost-smile-line', label: '动漫' },
            { icon: 'ri-earth-line', label: '纪录' },
            { icon: 'ri-music-2-line', label: '音乐' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-2">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-200 flex items-center justify-center text-primary-600">
                <i className={`${item.icon} text-xl md:text-2xl`} />
              </div>
              <span className="text-xs text-foreground-500">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}